<ng-container *ngIf="focusOnStageGroup?.id; else createMode">
  <nz-descriptions nzTitle="Stage Group Information" [nzColumn]="1">
    <nz-descriptions-item nzTitle="ID">{{focusOnStageGroup?.id}}</nz-descriptions-item>
  </nz-descriptions>
  <ng-container *ngTemplateOutlet="stagesTableTemplate"></ng-container>
  <button nz-button nzType="primary" (click)="submit('edit')" [disabled]="!name || !focusOnStageGroup?.stages?.length"
    style="margin-right: 5px;">Save</button>
  <button nz-button nzType="default" (click)="cancelFocus()">Cancel Focus</button>
</ng-container>
<ng-template #createMode>
  <ng-container *ngTemplateOutlet="stagesTableTemplate"></ng-container>
  <button nz-button nzType="primary" (click)="submit('create')"
    [disabled]="!name || !focusOnStageGroup?.stages?.length">Save</button>
</ng-template>

<ng-template #stagesTableTemplate let-stage>
  <nz-form-item>
    <nz-form-label nzLabelAlign="left" nzRequired nzFor="name">Group Name</nz-form-label>
    <nz-form-control>
      <input nz-input required [(ngModel)]="name" />
    </nz-form-control>
  </nz-form-item>
  <nz-table #basicTable [nzData]="focusOnStageGroup?.stages" [nzShowPagination]="true" [nzPageSize]="5"
    [nzSize]="'small'">
    <thead>
      <tr>
        <th>#</th>
        <th>Icon</th>
        <th>ID</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of basicTable.data; index as i">
        <td>{{i+1}}</td>
        <td>
          <img class="icon-url" [src]="item?.icon?.url ?? item?.iconUrl " alt="">
        </td>
        <td>{{ item?.id }}</td>
        <td>
          <button nz-button nzType="primary" nzDanger nzSize="small" (click)="remove(item.id)">Remove</button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</ng-template>